export const gameStateTypes = {
  game: "game",
  closed: "closed", // TODO: te gebruiken achteraf opwekking
  waiting: "waiting", //TODO: te gebruiken vooraf opwekking
};

export const gameAssignmentTypes = {
  plain: "plain",
  insta: "insta",
  password: "password",
};

export const noGame = {
  state: gameStateTypes.closed,
  startDate: null,
  assignments: [],
  gameId: null,
};

//TODO: deze zou ik niet gebruiken, ik zou aan de gameStartedIdX een datum toevoegen, want anders gaat iedereen "opeens"
// nog een request doen om de gamestate op te halen, dat zorgt voor een dikke piek in verkeer.
export const noGameWithDate = {
  state: gameStateTypes.closed,
  startDate: "Tue Apr 23 2024 20:05:55 GMT+0200 (Midden-Europese zomertijd)",
  assignments: [],
  gameId: null,
};

export const gameStartedId2 = {
  state: gameStateTypes.game,
  startDate: null,
  assignments: [
    { text: "Die linkshandig is", type: "plain" },
    { text: "Die op een boerderij woont", type: "plain" },
    { text: "Die weet wat hij later wil worden", type: "plain" },
    { text: "Die wel eens iets gebroken heeft", type: "password", password: "Marijn" },
    { text: "Een crompouce heeft gegeten", type: "plain" },
    { text: "Stop zoveel mogelijk mensen in de douche", type: "insta" },
    { text: "Een kat heeft", type: "plain" },
    { text: "Een pizza met ananas zou eten", type: "plain" },
    { text: "Een van de ouders een eigen bedrijf heeft", type: "plain" },
  ],
  gameId: 2,
  gameName: "Zondagavond: Kracht van de Geest",
};
